// extracted by mini-css-extract-plugin
module.exports = {"video__wrapper":"Video_video__wrapper__Wqu8O","video__player":"Video_video__player__76dsT"};